import { AxiosInstance } from 'axios';
import { ordersParse, RequestPayloadData } from './utils';
import { EventPoints } from './types';
import { handleErrorIntoService } from '@/tools/handleErrorIntoService';

const postOrderRequestData = (api: AxiosInstance) => ({
  postOrderRequest: async (payload: RequestPayloadData): Promise<any> => {
    return await api.post(EventPoints.ORDER_CREATE, {
      data: payload,
    });
  },
  postOrderRequest2: async (data: any): Promise<any> => {
    return await api.post(EventPoints.ORDER_CREATE, data);
  },
});

const getOrdersData = (api: AxiosInstance) => ({
  getOrders: async (params: any = { limit: 300 }): Promise<any> => {
    const { data } = await handleErrorIntoService(
      api.get(EventPoints.ORDERS_GET, {
        params,
      })
    );
    return { ...data, data: ordersParse(data.data) };
  },
});

const postCancelRequestData = (api: AxiosInstance) => ({
  postCancelRequest: async (id: string): Promise<any> => {
    const { data } = await handleErrorIntoService(
      api.post(`order/${id}/cancel`)
    );
    return { ...data };
  },
});

export const hideOrder = (api: AxiosInstance) => ({
  hide: async (id: string | number) => {
    const { data } = await handleErrorIntoService(
      api.post(`${EventPoints.PATCH_HIDE_ORDER}/${id}`)
    );
    return { ...data };
  },
});

const ordersService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...postOrderRequestData(api),
    ...getOrdersData(api),
    ...postCancelRequestData(api),
    ...hideOrder(api),
  };
};

export default ordersService;



// WEBPACK FOOTER //
// ./src/services/orders/ordersService.ts